import { render } from "./EmployeePendingRequests.vue?vue&type=template&id=fe933ffe"
import script from "./EmployeePendingRequests.vue?vue&type=script&lang=js"
export * from "./EmployeePendingRequests.vue?vue&type=script&lang=js"

import "./EmployeePendingRequests.vue?vue&type=style&index=0&id=fe933ffe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__